"use client";

import { c as _c } from "react/compiler-runtime";
import type { ApiWave } from "@/generated/models/ApiWave";
import { useCallback, useState } from "react";
import WaveDisableLinksEditorForm from "./WaveDisableLinksEditorForm";
import WaveSettingRow from "./WaveSettingRow";
import { useWaveSettingUpdater } from "./useWaveSettingUpdater";
interface WaveDisableLinksProps {
  readonly wave: ApiWave;
}
export default function WaveDisableLinks(t0) {
  const $ = _c(14);
  const {
    wave
  } = t0;
  const {
    canEdit,
    mutating,
    saveChatUpdate
  } = useWaveSettingUpdater(wave);
  const linksDisabled = wave.chat.links_disabled === true;
  const [draftLinksDisabled, setDraftLinksDisabled] = useState(linksDisabled);
  let t1;
  if ($[0] !== linksDisabled) {
    t1 = () => {
      setDraftLinksDisabled(linksDisabled);
    };
    $[0] = linksDisabled;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const resetEditor = t1;
  let t2;
  if ($[2] !== draftLinksDisabled || $[3] !== saveChatUpdate) {
    t2 = closeEditor => {
      saveChatUpdate(closeEditor, chat => ({
        ...chat,
        links_disabled: draftLinksDisabled
      }));
    };
    $[2] = draftLinksDisabled;
    $[3] = saveChatUpdate;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleSave = t2;
  let t3;
  if ($[5] !== draftLinksDisabled || $[6] !== handleSave || $[7] !== mutating) {
    t3 = t4 => {
      const {
        closeEditor: closeEditor_0
      } = t4;
      return <WaveDisableLinksEditorForm checked={draftLinksDisabled} disabled={mutating} onCancel={closeEditor_0} onCheckedChange={setDraftLinksDisabled} onSave={() => handleSave(closeEditor_0)} />;
    };
    $[5] = draftLinksDisabled;
    $[6] = handleSave;
    $[7] = mutating;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const renderEditor = t3;
  const t4 = linksDisabled ? "On" : "Off";
  let t5;
  if ($[9] !== canEdit || $[10] !== renderEditor || $[11] !== resetEditor || $[12] !== t4) {
    t5 = <WaveSettingRow canEdit={canEdit} editLabel="Edit disable links" label="Disable links" onOpen={resetEditor} renderEditor={renderEditor} valueLabel={t4} />;
    $[9] = canEdit;
    $[10] = renderEditor;
    $[11] = resetEditor;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}